export const FIREBASE_PROJECT_CONFIG = {
  projectId: "zoomdecor-react",
  authDomain: "zoomdecor-react.firebaseapp.com",
  storageBucket: "zoomdecor-react.firebasestorage.app",
  hostingSite: "zoomdecor-react",
  firestoreDatabase: "(default)",
};

export const FIREBASE_CLIENT_CONFIG = {
  apiKey: "AIzaSyBbukNoo8jW0qeq8wFk9_mp1XpyZMdooBw",
  authDomain: FIREBASE_PROJECT_CONFIG.authDomain,
  projectId: FIREBASE_PROJECT_CONFIG.projectId,
  storageBucket: FIREBASE_PROJECT_CONFIG.storageBucket,
  messagingSenderId: "147959761043",
  appId: "1:147959761043:web:8a3d204037f03c9fb66566",
  measurementId: "G-XR62H0YZYM",
};
